export default __webpack_public_path__ + "static/logo-9044928914f3668ffda97edd0e9e9f4f.png";